<main class="bg-white position-relative">
  <div class="payoutt_container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 O-M-2">
          <div class="title_content">
            <h1 class="text-uppercase text-white open_sans font_68 bold_700">Collection</h1>
            <p class="mt-lg-3 mt-xl-4 mt-2">On Payouttt, every sneaker you want is always available and
              authentic.</p>
            <div class="mt-lg-3 mt-xl-4">
              <a
                class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-lg-2 mt-xl-3"
                routerLink="/categories-detail">Shop
                Now</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 O-M-1 text-right">
          <img alt="" class="img-fluid" src="/assets/images/categories-shoes.png"/>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <section class="position-relative overflow-hidden" id="top_selling_sec">
    <div class="top_selling_container padd-top-bot">
      <div class="container product-slider-sec">
        <div class="row">
          <div class="col-md-4 col-lg-3">
            <div class="row align-items-center moblie-cate-title">
              <div class="col-md-6 category-title-top">
                <h4><b>Home/</b> Category</h4>
              </div>
              <div class="col-md-6">
                <div class="popularity-right-sec">
                  <h4><b>Sort By:</b></h4>
                  <div class="nice-select Wide" tabindex="0"><span
                    class="current">Popularity</span>
                    <ul class="list">
                      <li class="option selected" data-value="Price">Price High to Low</li>
                      <li class="option" data-value="High">Price Low to High</li>
                      <li class="option" data-value="Arrivals">New Arrivals</li>
                      <li class="option" data-value="Alphabetical">Alphabetical</li>
                      <li class="option" data-value="Reccomended">Reccomended for me</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="refine-sec-top">
              <div class="brand-header-top">
                <div class="brand-header">
                  <p>Refine (28 results)</p>
                  <span class="mines-plus-circle">
                                            <i aria-hidden="true" class="flaticon-minus"></i>
                                        </span>
                </div>
              </div>
              <div class="filter-right-sec">
                <div class="myaccordion active">
                  <div class="brand-header">
                    <h3>Brands</h3>
                    <span class="mines-plus-circle">
                                                <i aria-hidden="true" class="flaticon-minus"></i>
                                            </span>
                  </div>
                  <div class="inner-accordion">
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox3" type="checkbox" value="option1"/>
                      <label for="inlineCheckbox3"> Air Jordan </label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox1" type="checkbox" value="option2"/>
                      <label for="inlineCheckbox1"> Adidas </label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox2" type="checkbox" value="option3"/>
                      <label for="inlineCheckbox2"> Nike </label>
                    </div>
                  </div>
                </div>
                <div class="myaccordion active padd-top-40">
                  <div class="brand-header">
                    <h3>Sizes</h3>
                    <span class="mines-plus-circle">
                                                <i aria-hidden="true" class="flaticon-minus"></i>
                                            </span>
                  </div>
                  <div class="inner-accordion releasing-year-top">
                    <div class="sizes-input-field">
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox10" type="checkbox" value="option10"/>
                        <label for="inlineCheckbox10"> Mens </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox11" type="checkbox" value="option11"/>
                        <label for="inlineCheckbox11"> Gradeschool</label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox12" type="checkbox" value="option12"/>
                        <label for="inlineCheckbox12"> Kids </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox13" type="checkbox" value="option13"/>
                        <label for="inlineCheckbox13"> Toddlers </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox14" type="checkbox" value="option14"/>
                        <label for="inlineCheckbox14"> Womens </label>
                      </div>
                      <div class="checkbox checkbox-inline">
                        <input id="inlineCheckbox15" type="checkbox" value="option15"/>
                        <label for="inlineCheckbox15"> Infant </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="myaccordion active padd-top-40">
                  <div class="brand-header">
                    <h3>Colors</h3>
                    <span class="mines-plus-circle">
                                                <i aria-hidden="true" class="flaticon-minus"></i>
                                            </span>
                  </div>
                  <div class="inner-accordion">
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox4" type="checkbox" value="option4"/>
                      <label for="inlineCheckbox4"> Red </label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox5" type="checkbox" value="option5"/>
                      <label for="inlineCheckbox5"> Blue</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox6" type="checkbox" value="option6"/>
                      <label for="inlineCheckbox6"> Green </label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox7" type="checkbox" value="option7"/>
                      <label for="inlineCheckbox7"> Black </label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input id="inlineCheckbox8" type="checkbox" value="option8"/>
                      <label for="inlineCheckbox8"> White </label>
                    </div>
                  </div>
                </div>
                <!--  <div class="padd-top-40">
                <div class="brand-header">
                    <h3>Releasing year</h3>
                </div>
                 <div class="inner-accordion releasing-year-top year-input-field">
                    <div class="sizes-input-field">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox41" value="option41" />
                            <label for="inlineCheckbox41"> 2020 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox34" value="option34" />
                            <label for="inlineCheckbox34"> 2019 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox35" value="option35" />
                            <label for="inlineCheckbox35"> 2018 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox36" value="option36" />
                            <label for="inlineCheckbox36"> 2017 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox37" value="option37" />
                            <label for="inlineCheckbox37"> 2016 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox38" value="option38" />
                            <label for="inlineCheckbox38"> 2015 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox39" value="option39" />
                            <label for="inlineCheckbox39"> 2014 </label>
                        </div>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" id="inlineCheckbox40" value="option40" />
                            <label for="inlineCheckbox40"> 2013 </label>
                        </div>
                    </div>
                </div>
            </div> -->
              </div>
            </div>
          </div>
          <div class="top_selling_slider_main col-md-8 col-lg-9">
            <div class="row align-items-center desktop-cate-title">
              <div class="col-lg-6 col-md-5 category-title-top">
                <h4><b>Home/</b> Category</h4>
              </div>
              <div class="col-lg-6 col-md-7">
                <div class="popularity-right-sec">
                  <h4><b>Sort By:</b></h4>
                  <div class="nice-select Wide" tabindex="0"><span
                    class="current">Popularity</span>
                    <ul class="list">
                      <li class="option selected" data-value="Price">Price High to Low</li>
                      <li class="option" data-value="High">Price Low to High</li>
                      <li class="option" data-value="Arrivals">New Arrivals</li>
                      <li class="option" data-value="Alphabetical">Alphabetical</li>
                      <li class="option" data-value="Reccomended">Reccomended for me</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="top_selling_slider row padd-top-product">
              <div class="top_selling_product_box col-lg-4 col-md-6">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_1.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low-The Ten</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 mobile-top-product">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_2.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low '07'-MoMA</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div
                class="top_selling_product_box col-lg-4 col-md-6 mobile-top-product mobile-top-product1">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_3.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Max 90-Desert Ore</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-inline-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/new_releases_product_1.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan 6
                    Retro DMP (2020)</a></h3>
                  <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-inline-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/new_releases_product_2.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                    Yeezy Boost 350 V2 Linen</a></h3>
                  <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-inline-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/new_releases_product_3.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan 1
                    Retro High Court Purple White</a></h3>
                  <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_1.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low-The Ten</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$230.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_2.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Force 1 Low '07'-MoMA</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid" src="/assets/images/top_selling_product_3.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Off-White x
                    Air Max 90-Desert Ore</a></h3>
                  <h4 class="mt-lg-1 mt-xl-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white position-relative overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-inline-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid"
                    src="/assets/images/featured_products_product_1.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                    Yeezy Boost 350 V2 Cinder</a></h3>
                  <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$255.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-inline-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid"
                    src="/assets/images/featured_products_product_2.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Adidas
                    Yeezy Boost 350 V2 Zebra</a></h3>
                  <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
              <div class="top_selling_product_box col-lg-4 col-md-6 padd-top-product">
                <div class="top_sell_img border bg-white overflow-hidden">
                  <div class="add-top-cart-btn">
                    <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                      Cart</a>
                  </div>
                  <a class="d-inline-block w-100 h-100 image_hover position-relative"
                     href="javascript:void(0);"><img
                    alt="" class="img-fluid"
                    src="/assets/images/featured_products_product_3.png"/></a>
                </div>
                <div class="top_sell_title text-center mt-3">
                  <h3><a class="open_sans bold_400 font_20" href="javascript:void(0);">Jordan 1
                    Retro High Court Purple White</a></h3>
                  <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$200.00</h4>
                </div>
                <div class="cart-btn-mobile ">
                  <a href="#"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Add To
                    Cart</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top_selling_product_box col-12 padd-top-product payouttt_offers_content text-center">
          <a class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_26"
             href="javascript:void(0);">View
            more</a>
        </div>
      </div>
    </div>
  </section>
</main>
